<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description:
-->
<template>
  <div class="routesView p10">
    <el-breadcrumb>
      <template v-for="item in routes">
        <el-breadcrumb-item :key="item.path || item.name" v-if="!item.path">{{
          item.name
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :key="item.path || item.name"
          v-if="item.path"
          :to="{ path: item.path, query: item.query }"
          >{{ item.name }}</el-breadcrumb-item
        >
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'routesView',
  components: {},

  data() {
    return {};
  },

  computed: {
    routes: function () {
      return this.$store.state.routeView.routes;
    }
  },

  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.routesView {
  background: #fff;
}
.p18 {
  padding: 18px;
}
.fg2 {
  flex-grow: 2;
}
</style>
